import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateWarehouseInterface {
  country?: any
  email?: string
  phoneNo?: string
  postalCode?: string
  state?: string
  stateCode?: string
  status?: boolean
  streetAddress?: string
  suburb?: string
  timeZone?: any
  warehouseCode?: string
  warehouseId?: string
  warehouseName?: string
  labelIds?: any
}

export const useUpdateWarehouse = () => {
  const mutate = useMutation(
    ({
      warehouseId,
      warehouseName,
      warehouseCode,
      phoneNo,
      email,
      streetAddress,
      suburb,
      state,
      stateCode,
      country,
      postalCode,
      status,
      timeZone,
      labelIds,
    }: UpdateWarehouseInterface) => {
      return putAPI(`/Warehouse/${warehouseId}`, {
        code: warehouseCode,
        name: warehouseName,
        email,
        phoneNo,
        address: {
          lineOne: streetAddress,
          lineTwo: '',
          city: suburb,
          suburb: suburb,
          state: state,
          stateCode: stateCode,
          country: country.label,
          countryCode: country.value,
          postCode: postalCode,
        },
        isActive: status,
        timeZone: timeZone?.value,
        labelIds: labelIds,
      })
    },
  )

  return mutate
}

export default useUpdateWarehouse
